import React from 'react'
import Navbar from './Navbar/Navbar'
import Body from './Body/body';
import Footer from './Footer/footer'
import './App.css'


function App() {
  return (<>
    <Navbar />
    <Body />
    <Footer />
  </>);
}

export default App;
